<template>
  <div v-if="loading">

    <oil-cap v-if="products"
             :title="tableTitle"
             :buttons="tableButtons"
    />
    <v-divider class="my-2"/>
    <oil-table
        :keys="tableKeys"
        :items="products"
        :paginate='count'
        @paginateAction="productPaginate"
    >
      <template v-slot:Id="{value}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs"
                   v-on="on" icon
                   @click.stop="handleRowClick(value)">
              <v-icon color="primary">
                mdi-pen
              </v-icon>
            </v-btn>
          </template>
          <span>РЕДАКТИ́РОВАТЬ</span>
        </v-tooltip>
      </template>

      <template v-slot:DeleteId="{value}">
        <v-row>
          <v-col
            md="6"
            offset-md="3"
          >
            <oil-modal
              :value="value"
              tooltipMessage="УДАЛИТЬ"
              mdiIcon="mdi-delete"
              :accept="accept"
            />

          </v-col>
        </v-row>

      </template>
    </oil-table>

  </div>
</template>

<script>
import {productsService} from '@/services/ProductsService'
import { buttons,keys } from "./setting/products.json"
import { terminalService } from '~/services/TerminalService'

export default {
  data: () => ({
    tableTitle: 'Товары',
    tableButtons: buttons,
    tableKeys: keys,
    loading: false,
    products: [],
    count:{
      count:0
    }
  }),
  async created() {
    await this.productPaginate((this.currentPage-1)*10);
    // const response = await productsService.getAll()
    // this.products = response.data.map(product => {
    //   return {
    //     DeleteId: product.Id,
    //     ...product
    //   }
    // })
    this.loading = true
  },
  components: {
    OilTable: () => import('@/components/helper/oil.table'),
    OilCap: () => import('@/components/helper/oil.cap'),
    OilModal: () => import('@/components/helper/form/oil.delete.modal'),
  },
  methods: {
    handleRowClick(Id) {
      this.$router.push(`/product/${Id}`)
    },
    onSearchValueChange(data) {
      this.products = data
    },
    async productPaginate(page) {
      const terminals = await productsService.paginate(page)
      const {count, dates} = terminals.data
      this.count.count = count
      this.products = dates?.map(m => {
        return{
          DeleteId: m.Id,
          ...m
        }

      })
    },
    async accept(id) {
      const isDelete = await productsService.delete(id)
      if (isDelete.data) {
        const product = this.products.find(({Id}) => Id === id)
        const index = this.products.indexOf(product)
        this.products.splice(index, 1)
        this.$notify({
          group: 'mgs',
          type: 'success',
          title: `ТОВАР под названием ${product.Name} удачно удален`
        })
      }
    },
  }
}
</script>
